import {
  CollectionStatus,
  useAvailableTaskCollections,
  useListTaskCollections,
} from '@task-manager/entities/task-collections';
import { Select } from '@/shared/ui';
import css from './task-collection-select.module.scss';

type TaskCollectionSelectProps = {
  /** When set, the dropdown shows availability indicators per collection. */
  itineraryId?: string;
  value: string | undefined;
  onChange: (collectionId: string) => void;
  placeholder?: string;
  /** Render the dropdown in a portal — needed inside modals so it isn't
   * clipped/stacked behind the overlay. */
  usePortal?: boolean;
  /** Greys out the picker — applying a collection clones task rows (a write). */
  disabled?: boolean;
};

export const TaskCollectionSelect = ({
  itineraryId,
  value,
  onChange,
  placeholder = 'Select a collection…',
  usePortal = false,
  disabled = false,
}: TaskCollectionSelectProps) => {
  const list = useListTaskCollections({ limit: 100, offset: 0 });
  const available = useAvailableTaskCollections(itineraryId);

  const availableIds = available.data
    ? new Set(available.data.map((c) => c.id))
    : undefined;

  const options =
    list.data?.data.map((c) => ({
      value: c.id,
      label: c.title,
    })) ?? [];

  return (
    <div className={css.root}>
      <Select
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        options={options}
        placeholder={placeholder}
        searchable
        usePortal={usePortal}
        value={value ?? ''}
      />
      {itineraryId && value ? (
        <CollectionStatus available={availableIds?.has(value)} />
      ) : null}
    </div>
  );
};
